<script lang="ts" setup>
import {computed, onMounted, onUnmounted, ref, useSlots, useTemplateRef} from "vue";

const props = defineProps<{
  totalItems: number,
  currentIndex: number,
}>()

const slots = useSlots()
const wrapper = useTemplateRef<HTMLDivElement>('wrapper')
const wrapperWidth = ref(0)

const trackStyle = computed(() => {
  return {
    transform: `translateX(-${props.currentIndex * wrapperWidth.value}px)`,
    width: `${props.totalItems * 100}%`, // Make track wide enough for all items
  }
})

const items = computed(() => Object.keys(slots))

function updateWrapperWidth() {
  wrapperWidth.value = wrapper.value?.clientWidth ?? 0
}

onMounted(() => {
  updateWrapperWidth()
  if (typeof window !== 'undefined') {
    window.addEventListener('resize', updateWrapperWidth)
  }
})

onUnmounted(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', updateWrapperWidth)
  }
})

</script>

<template>
  <div ref="wrapper" class="relative w-full overflow-hidden max-w-full">
    <div
      v-if="items.length"
      class="flex transition-transform duration-500 ease-in-out overflow-hidden"
      :style="trackStyle"
    >
      <div
        v-for="item in items"
        :key="item"
        class="w-full flex-shrink-0 px-1"
        :style="`max-width: ${wrapperWidth}px`"
      >
        <slot :name="item"/>
      </div>
    </div>
  </div>
</template>
